// NPM
import React from 'react';
import _ from 'lodash';

// State
import { useSelector } from 'react-redux';

// Constants
import constants from './constants';

// Components
import SeatDistributionGroup from './SeatDistributionGroup';

export default function SeatDistributionArea(props) {
  const responsiveView = useSelector(state => state.responsiveView.value);
  
  // Constants
  const { data } = props;

  return data.map((group, groupIndex) => {
    return (
      <SeatDistributionGroup 
        key={ `SeatDistributionGroup-${ groupIndex }` }
        seatDistributionGroup={ group } 
        previousGroups={ _.slice(data, 0, groupIndex) }
      />
    )
  })
}